PageApp.Views.AdminHeaderView = Backbone.Marionette.ItemView.extend({
  template: hbs.templates.adminHeader,
  initialize: function (options) {
    this.options = options
  },
  serializeData: function () {
    var logoToUse = 'logo.png'
    var webAppName = myApp.ent.webApp.get('name')
    if (webAppName && webAppName.toLowerCase() === 'webtron') {
      logoToUse = 'logo_webtron.png'
    }
    var content = {
      contextPath: myApp.ent.config.get('contextPath'),
      logoToUse: logoToUse
    }
    return content
  }
})
